import {http} from './index';
import {ClassAllocationSaveTypes} from '@types';

// [class-allocation]-新增|编辑
export const classAllocationSaveApi = (params: ClassAllocationSaveTypes) => http.post('/teaching-workbench/answer/class/rule/save', params);